import { Component, Element, Prop, State, Watch, h } from '@stencil/core';

import { VehicleOption } from '../../../interfaces/interface.vehicle';
import { trackVehDetail } from '../../../tracking/tracking.detail';

@Component({
  tag: 'standard-equipment-modal',
  styleUrl: 'standard-equipment-modal.css',
})
// eslint-disable-next-line @stencil-community/ban-prefix
export class StandardEquipmentModal {
  @Element() el: HTMLElement;

  @Prop() options: VehicleOption[] = [];
  @Prop() answerOptions: { optionId: number; isSelected: boolean }[] = [];
  @Prop() setSelectedEquipment: (option: VehicleOption, isSelected: boolean) => void;

  @State() selectedOptionIds: number[] = [];

  @Watch('answerOptions')
  setSelectedIds() {
    const newSelectedIds = this.answerOptions.reduce((acc, option) => {
      if (option.isSelected) {
        acc.push(option.optionId);
      }
      return acc;
    }, []);

    this.selectedOptionIds = newSelectedIds;
  }

  componentWillLoad() {
    this.setSelectedIds();
  }

  openModal(evt: MouseEvent) {
    trackVehDetail('seeStandardEquipment', 'click');
    evt.preventDefault();
    const modal = this.el.querySelector('ico-modal#standard-equiment-modal') as HTMLIcoModalElement;
    modal.open();
  }

  closeModal() {
    const modal = this.el.querySelector('ico-modal#standard-equiment-modal') as HTMLIcoModalElement;
    modal.close();
  }

  render() {
    return (
      <div>
        <ico-hyperlink href="#" class="text-sm no-underline" noUnderline={true} onClick={(evt) => this.openModal(evt)}>
          See standard equipment
        </ico-hyperlink>

        <ico-modal id="standard-equiment-modal">
          <div slot="header">
            <div class="ico-components-heading mb-3">Standard Equipment</div>
            <div class="mb-3 text-sm">The pre-selected features are probably on your car. Please review and make any changes.</div>
          </div>

          <div class="flex flex-wrap gap-4">
            {this.options.map((option) => {
              return (
                <input-checkbox-toggle
                  titleText={option.displayName}
                  isChecked={this.selectedOptionIds.includes(option.optionId)}
                  whenChanged={(isSelected) => {
                    this.setSelectedEquipment(option, isSelected);
                  }}
                  isLocked={option.isLocked}
                />
              );
            })}
          </div>
          <div slot="footer" class="flex flex-row justify-end">
            <ico-button label="Done" buttonSize="large" whenClicked={() => this.closeModal()} />
          </div>
        </ico-modal>
      </div>
    );
  }
}
